<div class="table-description">
  <div class="title-description-container">
    <div class="header-icon">
      <i class="pi pi-truck large-icon"></i>
    </div>
    <div class="title-description">
      <h4 class="title">Delivery Windows</h4>
      <div class="subtitle">Create and view delivery windows.</div>
    </div>
  </div>

  @if (deliveryWindows().length) {
    <p-button label="Create Delivery Window" severity="success" icon="pi pi-plus" (click)="onCreateDeliveryWindow()" />
  }
</div>

<app-delivery-window-form-dialog
  [visible]="showFormDialog()"
  [mode]="dialogMode()"
  [value]="selectedDeliveryWindow()"
  [loading]="saving()"
  (formSubmit)="submitDeliveryWindowData($event)"
  (cancel)="cancelSubmission()"
  (visibleChange)="dialogVisibility($event)"
></app-delivery-window-form-dialog>
